import { Component } from "@angular/core";
import { CoreIcon } from "@svs/angular";

@Component({
  selector: "app-chat-answer-error",
  imports: [
    CoreIcon,
  ],
  templateUrl: "./chat-answer-error.component.html",
  styleUrl: "./chat-answer-error.component.scss",
})
export class ChatAnswerErrorComponent {

}
